import { Component, EventEmitter, Input, Output } from '@angular/core'

import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { DeliverableSection } from '@app/features/scope-overview/model/deliverable-section'
import { Dictionary } from 'lodash'
import { MenuOptions } from '@app/core/model/definitions/menu-options.interface'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeElementsService } from '../services/scope-elements.service'
import { UpdateFeeItemPayload, UpdateRolePayload, UpdateTpcPayload, ScopeElementsConfig } from '../models'
import { User } from '@app/core/model/user.model'
import { trackById } from '@app/shared/utils/utils'

@Component({ selector: 'scope-deliverable-sections', templateUrl: './deliverable-sections.component.html' })
export class DeliverableSectionsComponent {
  @Input() deliverable: Deliverable
  @Input() sections: DeliverableSection[]
  @Input() componentsMap: Dictionary<ScopeComponent[]>
  @Input() feeMenuOptions: MenuOptions[]
  @Input() componentMenuOptions: MenuOptions[]
  @Input() currentUser: User
  @Input() config: ScopeElementsConfig
  @Input() level: number

  @Output() onUpdateComponent = new EventEmitter<ScopeComponent>()
  @Output() onOverrideComponentQuantity = new EventEmitter<ScopeComponent>()
  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onMoveComponent = new EventEmitter<{ component: ScopeComponent; deliverable: Deliverable }>()
  @Output() onMoveComponentOutsideDeliverable = new EventEmitter<ScopeComponent>()
  @Output() onUpdateComponentTpc = new EventEmitter<UpdateTpcPayload>()
  @Output() onReorderComponentTpcs = new EventEmitter<any>()
  @Output() onUpdateDeliverableSectionTpc = new EventEmitter<UpdateTpcPayload>()
  @Output() onReorderDeliverableSectionTpcs = new EventEmitter<any>()
  @Output() onUpdateFeeItem = new EventEmitter<UpdateFeeItemPayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  constructor(protected scopeElementsService: ScopeElementsService) {}

  protected readonly trackById = trackById
}
